import React from "react";
//#region types
import { FormEnums } from "models/enums";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { BusinessUnitFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { BusinessUnitFormViewProps } from "models/propTypes/businessUnitPropTypes";
import { TableListSelectionFieldProps } from "models/propTypes/genericFormProps";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
//#region  components
import { Grid } from "@mui/material";
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

function useMembersFields(props: BusinessUnitFormViewProps): GenericFormSection<BusinessUnitFormTypes.Create>[] {
  const businessUnitService = useBusinessUnitService();
  const { excludeMemberIds } = props;

  const onSearch = React.useCallback(
    (searchText: string) => {
      return businessUnitService.availablePersonsAutoComplete(searchText, excludeMemberIds);
    },
    [excludeMemberIds]
  );

  return [
    {
      label: TranslationKeys.Company.Employees,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      icon: IconDefinitionConstants.WPerson,
      innerFields: {
        members: {
          label: TranslationKeys.Common.Persons,
          type: FormEnums.FormFieldType.TABLELISTSELECTION,
          extraProps: {
            resultTableProperties: {
              Name: {
                formatter: (value: BusinessUnitFormTypes.BusinessUnitMember) => (
                  <Grid item container direction="column">
                    <Grid item className={cssExports.tableListMainText}>
                      {value.name}
                    </Grid>
                  </Grid>
                ),
              },
            },
            search: (searchText: string) => onSearch(searchText),
            getSuggestions: () => onSearch(""),
            valueFormatter: (value: SelectionItem) => ({ employeeId: value.id, name: value.value }),
            icon: IconDefinitionConstants.WBusinessCard,
            entityText: TranslationKeys.BusinessUnit.Members,
            idFieldKey: FormFieldConstants.BusinessUnit.BusinessUnitMember.EmployeeId,
            addItemDialogSubTitle: LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.BusinessUnit.AddMembersDescription
            ),
          } as TableListSelectionFieldProps<BusinessUnitFormTypes.BusinessUnitMember>,
        },
      },
    },
  ];
}

export default useMembersFields;
